import PRODUCT_TYPE from "../const/products";
var isPN4Type = function (type) {
    return type === PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR;
};
export default isPN4Type;
//# sourceMappingURL=isPN4Type.js.map